export const XPER_MINT = 'XPER_MINT';
export const TOKEN_SEND_CONDITIONS_UPDATE = 'TOKEN_SEND_CONDITIONS_UPDATE';
export const SET_TOKEN_SEND_CONDITIONS_INFO = 'SET_TOKEN_SEND_CONDITIONS_INFO';
export const TOKEN_SEND_CONDITIONS_INFO_REQUEST = 'TOKEN_SEND_CONDITIONS_INFO_REQUEST';
export const NOTIFICATION_SETTING_UPDATE = 'NOTIFICATION_SETTING_UPDATE';
export const SET_NOTIFICATION_SETTING_INFO = 'SET_NOTIFICATION_SETTING_INFO';
export const NOTIFICATION_SETTING_INFO_REQUEST = 'NOTIFICATION_SETTING_INFO_REQUEST';
export const SET_DASHBOARD_USAGE_AND_DESTROY = 'SET_DASHBOARD_USAGE_AND_DESTROY';
export const DASHBOARD_USAGE_AND_DESTROY_REQUEST = 'DASHBOARD_USAGE_AND_DESTROY_REQUEST';
export const SET_DASHBOARD_MINTING = 'SET_DASHBOARD_MINTING';
export const DASHBOARD_MINTING_REQUEST = 'DASHBOARD_MINTING_REQUEST';
export const SET_DASHBOARD_AVAILIABLE_BALANCE = 'SET_DASHBOARD_AVAILIABLE_BALANCE';
export const DASHBOARD_AVAILABLE_BALANCE_REQUEST = 'DASHBOARD_AVAILABLE_BALANCE_REQUEST';
export const SET_DASHBOARD_SUMMARY = 'SET_DASHBOARD_SUMMARY';
export const DASHBOARD_SUMMARY_REQUEST = 'DASHBOARD_SUMMARY_REQUEST';

export const WALLET_RESPONSE_MESSAGE = 'WALLET_RESPONSE_MESSAGE';
